/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Reportingapikeys_Rotate_Warning2Inputs */

const en_settings_reportingapikeys_rotate_warning2 = /** @type {(inputs: Settings_Reportingapikeys_Rotate_Warning2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rotating replaces this key immediately. The current key stops working the moment the new key is generated – there is no grace period. Coordinate with the client so they can switch to the new key.`)
};

/**
* | output |
* | --- |
* | "Rotating replaces this key immediately. The current key stops working the moment the new key is generated – there is no grace period. Coordinate with the cli..." |
*
* @param {Settings_Reportingapikeys_Rotate_Warning2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_reportingapikeys_rotate_warning2 = /** @type {((inputs?: Settings_Reportingapikeys_Rotate_Warning2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Reportingapikeys_Rotate_Warning2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_reportingapikeys_rotate_warning2(inputs)
});
export { settings_reportingapikeys_rotate_warning2 as "settings_reportingApiKeys_rotate_warning" }